import { render, staticRenderFns } from "./PriceOverrides.vue?vue&type=template&id=15e7eb98"
import script from "./PriceOverrides.vue?vue&type=script&lang=js"
export * from "./PriceOverrides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports